const abbreviations = [
    {short: "USA", long: "United States"},
    {short: "UK", long: "United Kingdom"}
]
export default abbreviations;